import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import { ItemApi } from "../../../../../../../../../../services/Api/Organization/types";
import BlockProductOrderSourcesCard from "../../../../../../components/Order/BlockProduct/BlockProductOrderSourcesCard";
import BlockProductOrderTypesCard from "../../../../../../components/Order/BlockProduct/BlockProductOrderTypesCard";

interface Props {
	form: UseFormReturn<ItemApi>;
}

const BlockItemForm = ({ form }: Props) => {
	const {
		formState: { errors },
		control,
		register,
		watch,
		setValue,
	} = form;
	const { t } = useTranslation();

	return (
		<div className="d-flex flex-column">
			<hr />
			<FormCheck
				type="switch"
				register={register}
				label={t("modules.item_group.field.suspension.title")}
				name="suspended"
				errors={errors}
			/>
			{watch("suspended") && (
				<>
					<FormDatePicker
						errors={errors}
						control={control}
						name="suspension.until"
						label={t("modules.live_order.field.until.title")}
						placeholder={t("modules.live_order.field.until.placeholder")}
					/>
					<FormInput
						name="suspension.reason"
						errors={errors}
						register={register}
						label={t("modules.live_order.field.reason.title")}
						as="textarea"
					/>
					<BlockProductOrderTypesCard
						handleSetOrderTypes={(orderTypes) => setValue("suspension.order_types", orderTypes)}
						watchedOrderTypes={watch("suspension.order_types")}
					/>
					<BlockProductOrderSourcesCard
						handleSetSources={(sources) => setValue("suspension.sources", sources)}
						watchedSources={watch("suspension.sources")}
					/>
				</>
			)}
		</div>
	);
};

export default BlockItemForm;
